import { EReportContext } from '@/enums/reports';

export default [
  {
    path: '/player/:id',
    name: 'player',
    redirect: { name: 'player.view' },
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/player/:id/view/:context(batting|pitching)?',
    name: 'player.view',
    meta: { requiresAuth: true },
    components: {
      header: () => import('@/components/core/CoreHeader.vue'),
      drawer: () => import('@/components/core/CoreDrawer.vue'),
      default: () => import(/* webpackChunkName: "playerProfiles" */ '@/modules/player-profiles/PlayerProfile.vue'),
    },

    props: {
      default: (route) => {
        return {
          id: Number(route.params.id),
          context: route.params.context || EReportContext.BATTING.key,
          reportType: route.params.reportType || 'summary',
        };
      },
    },
    children: [
      {
        path: ':reportType(summary|release-point|release-extension|pitch-movement|pitch-location|pitch-location-2|performance-tracking|strike-zone|strike-zone-2|spray-chart)',
        name: 'player.report',
        component: () => import(/* webpackChunkName: "playerProfiles" */ '@/modules/player-profiles/ProfileReport.vue'),
        props: true,
      },
      {
        path: ':reportType(videos)/:action?/:vid(\\d+)?/:share?',
        name: 'player.videoList',
        component: () => import(
          /* webpackChunkName: "playerProfiles" */
          '@/modules/player-profiles/ProfileReport.vue'
        ),
        props: true,
      },
    ],
  },
  {
    path: '/player/:id/print/:context(batting|pitching)',
    name: 'player.print',
    meta: { requiresAuth: true },
    components: {
      header: null,
      drawer: null,
      default: () => import(/* webpackChunkName: "playerProfiles" */ '@/modules/player-profiles/profile/Print.vue'),
    },
    props: {
      default: (route) => {
        const {
          id,
          context,
          reportType,
        } = route.params;
        return {
          id: Number(id),
          context: context || 'batting',
          reportType: reportType || 'print',
        };
      },
    },
    children: [
      {
        path: ':reportType(report)',
        name: 'player.print.report',
        component: () => import(/* webpackChunkName: "playerProfiles" */ '@/modules/player-profiles/views/PrintableReport.vue'),
        props: true,
      },
    ],
  }
];
